import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import type { CSSObject } from 'tss-react';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { SvgCalendar } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';

export interface CustomDateMonthSelectorProps {
  onClick: any;
  monthAndYear: string;
  isDisabled?: boolean;
  styles?: CSSObject;
}

const CustomDateMonthSelector: React.FC<CustomDateMonthSelectorProps> = ({
  onClick,
  monthAndYear,
  isDisabled,
  styles,
}) => {
  // styles
  const useStyles = makeStyles()({
    selectDatesField: {
      boxSizing: 'border-box',
      background: isDisabled
        ? patientAccessTheme.palette.grey[100]
        : patientAccessTheme.palette.status.white,
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      borderRadius: '4px',
      height: '39px',
      width: '193px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginRight: '12px',
      cursor: isDisabled ? 'default' : 'pointer',
      ...styles,
    },
  });

  const { classes } = useStyles();

  return (
    <>
      <Grid
        className={classes.selectDatesField}
        component="button"
        onClick={isDisabled ? () => {} : onClick}
      >
        <Typography
          fontSize="14px"
          lineHeight="25px"
          textColor={
            isDisabled
              ? patientAccessTheme.palette.text.lowemphasis
              : patientAccessTheme.palette.text.highemphasis
          }
          margin="0px 0px 0px 14px"
        >
          {monthAndYear}
        </Typography>
        <SvgCalendar
          height="20px"
          width="20px"
          style={{ marginRight: '10px' }}
        />
      </Grid>
    </>
  );
};

export default CustomDateMonthSelector;
